import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import ScrapedEventListPage from './scraped-event-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Scraped Events">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>            
            <Breadcrumb.Item active>Scraped Events</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <ScrapedEventListPage />
    </Panel>
  );
};

export default Page;
